import loadable from '@loadable/component';
import { AgentStatusGuard } from '../../../common/components/agent-status-guard';
import AgentFeedsPage from './feeds/page';
const AgentFeedDetailPage = loadable(() => import('./feeds/[id]/page'));

const NewsAgentsPage = loadable(() => import('./page'));
const AgentPage = loadable(() => import('./agents/[id]/page'));
const AgentNewPage = loadable(() => import('./agents/new/page'));
const AgentArticlesPage = loadable(() => import('./articles/page'));
const AgentArticlesFormPage = loadable(() => import('./articles/[id]/page'));
const AgentCandidatesPage = loadable(() => import('./candidates/page'));
const AgentCandidatesFormPage = loadable(
  () => import('./candidates/[id]/page')
);
const AgentDashboardPage = loadable(() => import('./dashboard/page'));
const AgentInsightsPage = loadable(() => import('./insights/page'));
const AgentInsightsDimListPage = loadable(() => import('./insights/dim/[dim]/page'));
const AgentInsightsDimDetailPage = loadable(() => import('./insights/dim/[dim]/[idOrSlug]/page'));
const AgentPromptPage = loadable(() => import('./prompts/page'));
const AgentPromptFormPage = loadable(() => import('./prompts/[id]/form'));
const AgentSetupWritingPage = loadable(() => import('./setup/writing/page'));
const AgentSetupWpressPage = loadable(() => import('./setup/publish/page'));
const AgentSetupFeedsProcessingPage = loadable(
  () => import('./setup/feeds-processing/page')
);
const AgentSetupChatbotPage = loadable(() => import('./setup/chatbot/page'));
const AgentSetupCmsSettingsPage = loadable(
  () => import('./setup/cms-settings/page')
);
const AgentSetupAdsPage = loadable(() => import('./setup/ads/page'));
const AgentSetupCmsAnalyticsPage = loadable(
  () => import('./setup/cms-analytics/page'),
);
const AgentSetupPressReleasesPage = loadable(
  () => import('./setup/press-releases/page'),
);
const AgentSetupGrowthPage = loadable(() => import('./setup/growth/page'));
const SlackIntegrationPage = loadable(() => import('./integrations/slack/page'));
const TelegramIntegrationPage = loadable(
  () => import('./integrations/telegram/page')
);
const AgentAuthorsPage = loadable(() => import('./authors/page'));
const AgentSourcesPage = loadable(() => import('./sources/page'));
const AgentWhitelistPage = loadable(() => import('./whitelist/page'));
const AgentApiKeysPage = loadable(() => import('./api-keys/page'));
const EditorialDeskPage = loadable(() => import('./editorial-desk/page'));
const AgentDigestsPage = loadable(() => import('./digests/page'));
const AgentDigestFormPage = loadable(() => import('./digests/form'));
const AgentDigestHistoryPage = loadable(() => import('./digests/history'));
const AgentCategoriesPage = loadable(() => import('./categories/page'));
const AgentConnectionsPage = loadable(() => import('./connections/page'));
const DeepResearchPage = loadable(() => import('./deep-research/page'));
const DeepResearchDetailPage = loadable(() => import('./deep-research/[id]/page'));
const AgentInvitePage = loadable(() => import('./agent-invite/page'));
const SuperAdminAgentsPage = loadable(() => import('./super-admin/agents/page'));
const SuperAdminChatbotSettingsPage = loadable(
  () => import('./super-admin/chatbot-settings/page')
);
const SuperAdminServerSettingsPage = loadable(
  () => import('./super-admin/server-settings/page')
);

export const routes = [
  {
    path: ':id',
    element: <AgentPage />,
  },
  {
    path: 'new',
    element: <AgentNewPage />,
  },
  {
    path: 'dashboard',
    element: <AgentDashboardPage />,
  },
  {
    path: 'insights',
    element: <AgentInsightsPage />,
  },
  {
    path: 'insights/dim/:dim',
    element: <AgentInsightsDimListPage />,
  },
  {
    path: 'insights/dim/:dim/:idOrSlug',
    element: <AgentInsightsDimDetailPage />,
  },
  {
    path: 'integrations/slack',
    element: <SlackIntegrationPage />,
  },
  {
    path: 'integrations/telegram',
    element: <TelegramIntegrationPage />,
  },
  {
    path: 'setup/writing',
    element: (
      <AgentStatusGuard>
        <AgentSetupWritingPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/publish',
    element: (
      <AgentStatusGuard>
        <AgentSetupWpressPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/feeds-processing',
    element: (
      <AgentStatusGuard>
        <AgentSetupFeedsProcessingPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/chatbot',
    element: (
      <AgentStatusGuard>
        <AgentSetupChatbotPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/growth',
    element: (
      <AgentStatusGuard>
        <AgentSetupGrowthPage />
      </AgentStatusGuard>
    ),
  },
  // {
  //   path: '',
  //   element: <NewsAgentsPage />,
  // },
  {
    path: 'articles',
    element: (
      <AgentStatusGuard>
        <AgentArticlesPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'articles/:id',
    element: (
      <AgentStatusGuard>
        <AgentArticlesFormPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'candidates',
    element: (
      <AgentStatusGuard>
        <AgentCandidatesPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'feeds',
    element: (
      <AgentStatusGuard>
        <AgentFeedsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'feeds/:id',
    element: (
      <AgentStatusGuard>
        <AgentFeedDetailPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'candidates/:id',
    element: (
      <AgentStatusGuard>
        <AgentCandidatesFormPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'prompts',
    element: (
      <AgentStatusGuard>
        <AgentPromptPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'prompts/:id',
    element: (
      <AgentStatusGuard>
        <AgentPromptFormPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'authors',
    element: (
      <AgentStatusGuard>
        <AgentAuthorsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'sources',
    element: (
      <AgentStatusGuard>
        <AgentSourcesPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'categories',
    element: (
      <AgentStatusGuard>
        <AgentCategoriesPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'connections',
    element: (
      <AgentStatusGuard>
        <AgentConnectionsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'deep-research',
    element: (
      <AgentStatusGuard>
        <DeepResearchPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'deep-research/:id',
    element: (
      <AgentStatusGuard>
        <DeepResearchDetailPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/whitelist',
    element: (
      <AgentStatusGuard>
        <AgentWhitelistPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/api-keys',
    element: (
      <AgentStatusGuard>
        <AgentApiKeysPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/cms-settings',
    element: (
      <AgentStatusGuard>
        <AgentSetupCmsSettingsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/ads',
    element: (
      <AgentStatusGuard>
        <AgentSetupAdsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/cms-analytics',
    element: (
      <AgentStatusGuard>
        <AgentSetupCmsAnalyticsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'setup/press-releases',
    element: (
      <AgentStatusGuard>
        <AgentSetupPressReleasesPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'editorial-desk',
    element: (
      <AgentStatusGuard>
        <EditorialDeskPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'digests',
    element: (
      <AgentStatusGuard>
        <AgentDigestsPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'digests/new',
    element: (
      <AgentStatusGuard>
        <AgentDigestFormPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'digests/history',
    element: (
      <AgentStatusGuard>
        <AgentDigestHistoryPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'digests/edit/:key',
    element: (
      <AgentStatusGuard>
        <AgentDigestFormPage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'agent-invite',
    element: (
      <AgentStatusGuard>
        <AgentInvitePage />
      </AgentStatusGuard>
    ),
  },
  {
    path: 'super-admin/agents',
    element: <SuperAdminAgentsPage />,
  },
  {
    path: 'super-admin/chatbot-settings',
    element: <SuperAdminChatbotSettingsPage />,
  },
  {
    path: 'super-admin/server-settings',
    element: <SuperAdminServerSettingsPage />,
  },
];
